var log = 1;
var d = 0;
window.impressionSearch = function (head, objs) {
    let items = [];
    objs.forEach((l, i) => {
        items.push({
            name: l.name,
            id: l.id,
            price: l.price ? parseFloat(l.price) : "",
            brand: l.category?.trim(),
            category:
                l.country.toLowerCase() == "italia" ? l.region : l.country,
            variant: l.locality,
            list: l.list,
            position: l.position,
        });
    });

    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
        event: "impressionSearch",
        ecommerce: {
            currencyCode: "EUR", // Local currency is optional.
            check_in: head.checkIn,
            check_out: head.checkOut,
            num_adults: head.nAdults,
            num_children: head.nChildren,
            impressions: items,
        },
    });
    if (log) console.log(dataLayer);
};

window.viewItemList = function (head, objs) {
    let items = [];
    objs.forEach((l, i) => {
        items.push({
            item_id: l.id,
            item_name: l.name,
            currency: "EUR",
            index: l.position,
            item_brand: l.category?.trim(),
            item_category: l.country,
            item_category_2: l?.region,
            item_category_3: l?.locality,
            item_list_name: l.list,
            item_list_id: l.listId,
            price: l.price ? parseFloat(l.price) : "",
            quantity: 1,
        });
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "view_item_list",
        check_in: head.checkIn,
        check_out: head.checkOut,
        num_adults: head.nAdults,
        num_children: head.nChildren,
        ecommerce: {
            items: items,
        },
    });

    if (log) console.log(window.dataLayer);
};

window.productClick = function (productObj, customurl) {
    if (typeof customurl == "undefined") customurl = null;
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
        event: "productClick",
        ecommerce: {
            click: {
                actionField: { list: productObj.list }, // Optional list property.
                products: [
                    {
                        name: productObj.name, // Name or ID is required.
                        id: productObj.id,
                        price: productObj.price
                            ? parseFloat(productObj.price)
                            : "",
                        brand: productObj.brand.trim(),
                        category:
                            productObj.country.toLowerCase() != "italia"
                                ? productObj.country
                                : productObj.region,
                        variant: productObj.locality,
                        position: productObj.position,
                    },
                ],
            },
        },
    });

    if (log) console.log(dataLayer);
};

window.select_item = function (productObj) {
    if (productObj.list == "Catalogo") productObj.listId = "PAGE_CATALOG";
    if (productObj.list == "Home") productObj.listId = "PAGE_HOME";
    if (productObj.list == "Destinazione") productObj.listId = "PAGE_DEST";
    if (productObj.list == "Offerte") productObj.listId = "PAGE_OFFERS";

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "select_item",
        check_in: productObj.checkIn,
        check_out: productObj.checkOut,
        num_adults: productObj.nAdults,
        num_children: productObj.nChildren,
        ecommerce: {
            items: [
                {
                    item_id: productObj.id,
                    item_name: productObj.name,
                    currency: "EUR",
                    index: productObj.position,
                    item_brand: productObj.brand.trim(),
                    item_category: productObj.country,
                    item_category_2: productObj.region,
                    item_category_3: productObj.locality,
                    item_list_name: productObj.list,
                    item_list_id: productObj.listId,
                    price: productObj.price ? parseFloat(productObj.price) : "",
                    quantity: 1,
                },
            ],
        },
    });
    if (log) console.log(window.dataLayer);
};

window.productDetail = function (productObj) {
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
        event: "productDetail",
        ecommerce: {
            detail: {
                actionField: { list: productObj.list }, // 'detail' actions have an optional list property.
                products: [
                    {
                        name: productObj.name, // Name or ID is required.
                        id: productObj.id,
                        price: productObj.price
                            ? parseFloat(productObj.price)
                            : "",
                        brand: productObj.brand.trim(),
                        category:
                            productObj.country.toLowerCase() != "italia"
                                ? productObj.country
                                : productObj.region,
                        variant: productObj.locality,
                        check_in: productObj.checkIn,
                        check_out: productObj.checkOut,
                        num_adults: productObj.nAdults,
                        num_children: productObj.nChildren,
                    },
                ],
            },
        },
    });
    if (log) console.log(window.dataLayer);
};

window.view_item = function (productObj) {
    if (productObj.list == "Catalogo") productObj.listId = "PAGE_CATALOG";
    if (productObj.list == "Dettaglio Struttura")
        productObj.listId = "PAGE_STRUCTURE";
    if (productObj.list == "Destinazione") productObj.listId = "PAGE_DEST";
    if (productObj.list == "Offerte") productObj.listId = "PAGE_OFFERS";

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "view_item",
        check_in: productObj.checkIn,
        check_out: productObj.checkOut,
        num_adults: productObj.nAdults,
        num_children: productObj.nChildren,
        ecommerce: {
            currency: "EUR",
            value: productObj.price ? parseFloat(productObj.price) : "",
            items: [
                {
                    item_id: productObj.id,
                    item_name: productObj.name,
                    currency: "EUR",
                    index: 1,
                    item_brand: productObj.brand.trim(),
                    item_category: productObj.country,
                    item_category_2: productObj.region,
                    item_category_3: productObj.locality,
                    item_list_name: productObj.list,
                    item_list_id: productObj.listId,
                    price: productObj.price ? parseFloat(productObj.price) : "",
                    quantity: 1,
                },
            ],
        },
    });
    if (log) console.log(window.dataLayer);
};

window.addToCart = function (productObj) {
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
        event: "addToCart",
        ecommerce: {
            currencyCode: "EUR",
            add: {
                // 'add' actionFieldObject measures.
                products: [
                    {
                        //  adding a product to a shopping cart.
                        name: productObj.name,
                        id: productObj.id,
                        price: productObj.price
                            ? parseFloat(productObj.price)
                            : "",
                        brand: productObj.brand.trim(),
                        category:
                            productObj.country.toLowerCase() != "italia"
                                ? productObj.country
                                : productObj.region,
                        variant: productObj.locality,
                        quantity: 1,
                        check_in: productObj.checkIn,
                        check_out: productObj.checkOut,
                        num_adults: productObj.nAdults,
                        num_children: productObj.nChildren,
                    },
                ],
            },
        },
    });
    if (log) console.log(dataLayer);
};

window.add_to_cart = function (productObj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "add_to_cart",
        check_in: productObj.checkIn,
        check_out: productObj.checkOut,
        num_adults: productObj.nAdults,
        num_children: productObj.nChildren,
        ecommerce: {
            currency: "EUR",
            value: productObj.price ? parseFloat(productObj.price) : "",
            items: [
                {
                    item_id: productObj.id,
                    item_name: productObj.name,
                    affiliation: "AFFILIATION",
                    coupon: "COUPON",
                    currency: "EUR",
                    index: 1,
                    item_brand: productObj.brand.trim(),
                    item_category: productObj.country,
                    item_category_2: productObj.region,
                    item_category_3: productObj.locality,
                    item_list_name: productObj.list,
                    item_list_id: "PAGE_SEARCHRESULT",
                    price: productObj.price ? parseFloat(productObj.price) : "",
                    quantity: 1,
                },
            ],
        },
    });
    if (log) console.log(window.dataLayer);
};

window.view_cart = function (productObj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "view_cart",
        check_in: productObj.checkIn,
        check_out: productObj.checkOut,
        num_adults: productObj.nAdults,
        num_children: productObj.nChildren,
        ecommerce: {
            currency: "EUR",
            value: productObj.price ? parseFloat(productObj.price) : "",
            items: [
                {
                    item_id: productObj.id,
                    item_name: productObj.name,
                    currency: "EUR",
                    index: 1,
                    item_brand: productObj.brand.trim(),
                    item_category: productObj.country,
                    item_category_2: productObj.region,
                    item_category_3: productObj.locality,
                    item_list_name: "Risultati Ricerca",
                    item_list_id: "PAGE_SEARCHRESULT",
                    price: productObj.price ? parseFloat(productObj.price) : "",
                    quantity: 1,
                },
            ],
        },
    });
    if (log) console.log(window.dataLayer);
};

window.slcheckout = function (step, stepName, product) {
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
        event: "checkout",
        ecommerce: {
            checkout: {
                actionField: { step: step, option: stepName },
                products: [
                    {
                        name: product.name,
                        id: product.id,
                        price: product.price
                            ? parseFloat(product.price)
                            : "", // Comprensivo di tutti i vari add-on calcolati nella procedura di pre-checkout
                        brand: product.brand.trim(),
                        category:
                            product.country.toLowerCase() != "italia"
                                ? product.country
                                : product.region,
                        variant: product.locality,
                        quantity: 1,
                        check_in: product.checkIn,
                        check_out: product.checkOut,
                        num_adults: product.nAdults,
                        num_children: product.nChildren,
                    },
                ],
            },
        },
        /* 'eventCallback': function() {
      document.location = window.location.href;
   }*/
    });

    if (log) console.log(dataLayer);
};
window.begin_checkout = function (productObj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "begin_checkout",
        check_in: productObj.checkIn,
        check_out: productObj.checkOut,
        num_adults: productObj.nAdults,
        num_children: productObj.nChildren,
        ecommerce: {
            currency: "EUR",
            value: productObj.price ? parseFloat(productObj.price) : "",
            items: [
                {
                    item_id: productObj.id,
                    item_name: productObj.name,
                    currency: "EUR",
                    index: 1,
                    item_brand: productObj.brand.trim(),
                    item_category: productObj.country,
                    item_category_2: productObj.region,
                    item_category_3: productObj.locality,
                    item_list_name: "Risultati Ricerca",
                    item_list_id: "PAGE_SEARCHRESULT",
                    price: productObj.price ? parseFloat(productObj.price) : "",
                    quantity: 1,
                },
            ],
        },
    });

    if (log) console.log(window.dataLayer);
};

window.add_shipping_info = function (productObj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "add_shipping_info",
        check_in: productObj.checkIn,
        check_out: productObj.checkOut,
        num_adults: productObj.nAdults,
        num_children: productObj.nChildren,
        ecommerce: {
            currency: "EUR",
            value: productObj.price ? parseFloat(productObj.price) : "",
            items: [
                {
                    item_id: productObj.id,
                    item_name: productObj.name,
                    currency: "EUR",
                    index: 1,
                    item_brand: productObj.brand.trim(),
                    item_category: productObj.country,
                    item_category_2: productObj.region,
                    item_category_3: productObj.locality,
                    item_list_name: "Risultati Ricerca",
                    item_list_id: "PAGE_SEARCHRESULT",
                    price: productObj.price ? parseFloat(productObj.price) : "",
                    quantity: 1,
                },
            ],
        },
    });

    if (log) console.log(window.dataLayer);
};

window.add_payment_info = function (productObj, payType) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "add_payment_info",
        check_in: productObj.checkIn,
        check_out: productObj.checkOut,
        num_adults: productObj.nAdults,
        num_children: productObj.nChildren,
        ecommerce: {
            currency: "EUR",
            value: productObj.price ? parseFloat(productObj.price) : "",
            payment_type: payType,
            items: [
                {
                    item_id: productObj.id,
                    item_name: productObj.name,
                    currency: "EUR",
                    index: 1,
                    item_brand: productObj.brand.trim(),
                    item_category: productObj.country,
                    item_category_2: productObj.region,
                    item_category_3: productObj.locality,
                    item_list_name: "Risultati Ricerca",
                    item_list_id: "PAGE_SEARCHRESULT",
                    price: productObj.price ? parseFloat(productObj.price) : "",
                    quantity: 1,
                },
            ],
        },
    });
    if (log) console.log(window.dataLayer);
};

window.doquote = function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "crea_preventivo",
    });
    console.log(window.dataLayer);
};

window.cshare = function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "click_condividi",
    });
};

window.form_quote = function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "form_preventivo",
    });
};

window.form_quote_structures = function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "form_preventivo_strutture",
    });
};

window.form_newsletter = function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "form_newsletter",
    });
};

window.form_contacts = function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "form_contatti",
    });
};

window.search_bar = function (searchObj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "search_bar",
        destinazione: searchObj.destinations,
        trasporto: searchObj.transports,
        check_in: searchObj.checkIn,
        check_out: searchObj.checkOut,
        num_adults: searchObj.nAdults,
        num_children: searchObj.nChildren,
        content_ids: '[]',
        city: '',
        region: '',
        country: '',
    });
};
window.click_pay = function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "click_pagamento",
    });
};


window.userdata = function (userData) {
	dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
	dataLayer.push({
		event: "user_data",
		user_data: {
		email: userData.email,
		sha256_email: userData.email_sha256,
		phone_number: userData.phoneNumber,
		sha256_phone_number:userData.phoneNumber_sha256,
		first_name:userData.firstName,
		last_name: userData.lastName,
		address: {
			street_address: userData.address.streetAddress,
			city: userData.address.city,
			region: userData.address.region,
			postal_code: userData.address.postalCode,
			country: userData.address.country
		}
	   }
	});
	console.log(dataLayer)
}
window.purchase3 = function (purchaseObj) {
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
        event: "Purchase",
        saldo_attuale: purchaseObj.totalPrice
            ? parseFloat(purchaseObj.amount)
            : "",
        ecommerce: {
            purchase: {
                actionField: {
                    id: purchaseObj.purchaseId, // Transaction ID. Required for purchases and refunds.
                    affiliation: "Online Store",
                    revenue: purchaseObj.totalPrice
                        ? parseFloat(purchaseObj.totalPrice)
                        : "", // Total transaction value (incl. tax and shipping)
                    tax: "",
                    shipping: "",
                    coupon: "",
                },
                products: [
                    {
                        // List of productFieldObjects.
                        name: purchaseObj.strName, // Name or ID is required.
                        id: purchaseObj.strId,
                        price: purchaseObj.totalPrice
                            ? parseFloat(purchaseObj.totalPrice)
                            : "",
                        brand: purchaseObj.brand.trim(),
                        category:
                            purchaseObj.country.toLowerCase() != "italia"
                                ? purchaseObj.country
                                : purchaseObj.region,
                        variant: purchaseObj.locality,
                        quantity: 1,
                        coupon: "", // Optional fields may be omitted or set to empty string.
                        check_in: purchaseObj.checkIn,
                        check_out: purchaseObj.checkOut,
                        num_adults: purchaseObj.nAdults,
                        num_children: purchaseObj.nChildren,
                    },
                ],
            },
        },
    });
};
window.purchase4 = function (purchaseObj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "purchase",
        saldo_attuale: parseFloat(purchaseObj.amount),
        check_in: purchaseObj.checkIn,
        check_out: purchaseObj.checkOut,
        num_adults: purchaseObj.nAdults,
        num_children: purchaseObj.nChildren,
        ecommerce: {
            transaction_id: purchaseObj.purchaseId,
            value: parseFloat(purchaseObj.totalPrice),
            currency: "EUR",
            coupon: "",
            tax: "",
            items: [
                {
                    item_id: purchaseObj.strId,
                    item_name: purchaseObj.strName,
                    currency: "EUR",
                    index: 1,
                    item_brand: purchaseObj.brand.trim(),
                    item_category: purchaseObj.country,
                    item_category_2: purchaseObj.region,
                    item_category_3: purchaseObj.locality,
                    item_list_name: "Esito Transazione",
                    item_list_id: "PAYRESULT",
                    price: parseFloat(purchaseObj.totalPrice),
                    quantity: 1,
                },
            ],
        },
    });
};


